<template>
    <div class="container">
        <!-- <img class="top_icon" :src="mbActiveOutput.actImgPath"/> -->
        <!-- <div class="top_icon" v-if="imgs.length>0">   @click="itemClick(item)"-->
        <img class="gallary-img" v-if="mbActiveOutput.templateType=='1'" src='../../assets/images/img_mall_zfq.png' />
        <section class="top_swiper_box" v-else-if="imgs.length>0">
            <swiper >
                <swiper-slide v-for="(item,index) in imgs" :key="index">
                    <img
                    class="gallary-img"
                    :src="item"
                    />
                </swiper-slide>
                <!-- <div class="swiper-pagination" slot="pagination"></div> -->
             </swiper>
                 <!-- <swiper-component :imgs="imgs" cclass="swiper_h"></swiper-component> -->
        </section>
        <!-- </div> -->
        <div class="top_info">
            <span class="top_info_span1">{{mbActiveOutput.actName}}</span>
            <span v-if="mbActiveOutput.exchangeType==0" class="top_info_span2">{{changeintegration}} 积分</span>
            <!-- <span v-if="mbActiveOutput.exchangeType==1" class="top_info_span2">{{changeintegration}} 积分+{{mbActiveOutput.moneyValue}} 元</span> -->
            <div v-if="mbActiveOutput.exchangeType==1" class="top_info_div">
                <span  class="top_info_div_span1">{{changeintegration}} 积分+{{mbActiveOutput.moneyValue}} 元</span><span  class="top_info_div_span2">积分可用 :{{integrationSum}}</span>
            </div>
            <div v-if="mbActiveOutput.exchangeType==2" class="top_info_div">
                <span  class="top_info_div_span1">￥{{mbActiveOutput.moneyValue}} 元</span><span  class="top_info_div_span2">积分可用 :{{canUseintegrationSum}}</span>
            </div>
            <span v-if="mbActiveOutput.exchangeType==2" class="top_info_span22">{{mbActiveOutput.exchangeRule}} 积分/元,最高可用{{mbActiveOutput.exchangeTop}},剩余部分线上支付</span>
            <!-- <span v-if="mbActiveOutput.exchangeType==2" class="top_info_span2">积分抵扣上限{{mbActiveOutput.exchangeTop  }}</span> -->
            <span class="top_info_span3">剩余:{{overTime}}</span>
        </div>
        <div class="bodyTopLine"></div>
        <div class="body">
            <span class="body_span1">兑换规则</span>
            <span class="body_span2">{{mbActiveOutput.actSubtitle}}</span>
            <span  class="body_span1">兑换详情</span>
            <div v-if="mbActiveOutput.actDetail" class="body_html" v-html="mbActiveOutput.actDetail"></div>
        </div>
        <!-- exchangeData && -->
        <!-- <div v-if="!orderNo && mbActiveOutput.exchangeNum>0 && mbActiveOutput.exchangeType==2 
                &&( ( mbActiveOutput.exchangeFlag==true))">
                显示兑换积分11111111111
        
        </div> -->

        <div class="ExchangefootBg">
            <!-- @click="goPayCenter(orderNo)" -->
            <span  v-if="orderNo" class="Exchangefoot_span" @click="goPayCenter(orderNo)" >立即支付</span>
            <span  v-else-if="mbActiveOutput.exchangeFlag==false &&exchangeData && exchangeData.exchangeNum>0" class="Exchangefoot_span1">兑换时间{{exchangeData.beginTime}}-{{exchangeData.endTime}}</span>
            <span  v-else-if="mbActiveOutput.exchangeFlag==false && exchangeData && exchangeData.exchangeNum==0"  class="Exchangefoot_span1">已抢光</span>
            <span  v-else-if="mbActiveOutput.exchangeNum==0"  class="Exchangefoot_span1">已抢光</span>

            <span  v-else-if="integrationSum<changeintegration&&mbActiveOutput.exchangeType!=2" class="Exchangefoot_span1">您的积分不足</span>
            <span @click="showPopupAction()" v-else  class="Exchangefoot_span">立即兑换</span>
        </div>

         <mt-popup v-model="showPopup" position="bottom" class="mint-popup">

            <div class="popup">
                <div class="popupTop">
                    <span class="popupTop_span1" @click="closePopupAction()">取消</span>
                    <span class="popupTop_span2">确认订单</span>
                </div>
                <div class="addressView" v-if="mbActiveOutput.templateType!='1'" >
                    <div class="addressViewBG">
                        <div class="addressView_left">
                            <div class="addressView_left_div">
                                <img class="addressView_left_icon" src="../../assets/images/icon_ziti_address_icon.png"/>
                                <span class="addressView_left_span1">自提地址</span>
                            </div>
                            <span class="addressView_left_span2" >{{mbActiveOutput.selfLiftingAddress}}</span>
                        </div>
                        <div class="addressView_line"></div>
                        <div class="addressView_right" @click="copyTradeCode()" :data-clipboard-text="mbActiveOutput.selfLiftingAddress">
                            <img class="addressView_right_icon" src="../../assets/images/icon_btn_duplicate_icon.png"/>
                            <span class="addressView_right_span" >复制</span>
                        </div>
                    </div>
                </div>

                <div class="popupJifen1" v-if="mbActiveOutput.exchangeType ==0" >
                    <div class="popupJifen_div">
                        <div class="popupJifen_div_left">
                          <span class="popupJifen_div_span1">兑换数量</span>
                          
                        </div>
                        <div class="popupJifen_div_right">
                          <section class="buy_num_right">
                            <span class="reduce" @click="reduce"><img src="../../assets/images/btn_reduce.png"></span>
                            <input type="number" v-model.number="exchangeNum" @input="inputExchangeNum">
                            <span class="add" @click="add"><img src="../../assets/images/btn_add.png"></span>
                          </section>
                        </div>
                     </div>
                     <div class="popupJifen_div">
                        <div class="popupJifen_div_left">
                          <span class="popupJifen_div_span1">本次兑换消耗积分:</span>
                          
                        </div>
                        <div class="popupJifen_div_right">
                          <span class="popupJifen_div_span4">{{ allExchangeValue }}</span>
                        </div>
 
                     </div>
                    <!-- <span   class="popupJifen_span1">本次兑换消耗积分:</span>
                    <span  class="popupJifen_span2">{{mbActiveOutput.exchangeValue}}</span> -->
                </div>
                <div class="popupJifen1" v-if="mbActiveOutput.exchangeType ==1" >
                    
                    <div class="popupJifen_div">
                        <div class="popupJifen_div_left">
                          <span class="popupJifen_div_span1">兑换数量</span>
                          
                        </div>
                        <div class="popupJifen_div_right">
                          <section class="buy_num_right">
                            <span class="reduce" @click="reduce"><img src="../../assets/images/btn_reduce.png"></span>
                            <input type="number" v-model.number="exchangeNum" @input="inputExchangeNum">
                            <span class="add" @click="add"><img src="../../assets/images/btn_add.png"></span>
                          </section>
                        </div>
                     </div>

                    <div class="popupJifen_div">
                       <div class="popupJifen_div_left">
                         <span class="popupJifen_div_span1">积分抵扣</span>
                         <span class="popupJifen_div_span2">使用积分{{ allExchangeValue }},积分余额{{integrationSum-allExchangeValue  }}</span>
                       </div>
                       <div class="popupJifen_div_right">
                         <span class="popupJifen_div_span3">-{{ allExchangeValue }}积分</span>
                       </div>

                    </div>

                    <div class="popupJifen_div">
                       <div class="popupJifen_div_left">
                         <span class="popupJifen_div_span1">支付金额</span>
                         
                       </div>
                       <div class="popupJifen_div_right">
                         <span class="popupJifen_div_span4">￥{{ allMoneyValue }}</span>
                       </div>

                    </div>
                
                </div> 
                
                <div class="popupJifen1" v-if="mbActiveOutput.exchangeType ==2" >

                    <div class="popupJifen_div">
                        <div class="popupJifen_div_left">
                          <span class="popupJifen_div_span1">商品金额</span>
                          
                        </div>
                        <div class="popupJifen_div_right">
                          <span class="popupJifen_div_span4">￥{{ mbActiveOutput.moneyValue }}</span>
                        </div>
                    </div>

                    <div class="popupJifen_div">
                        <div class="popupJifen_div_left">
                          <span class="popupJifen_div_span1">兑换数量</span>
                          
                        </div>
                        <div class="popupJifen_div_right">
                          <section class="buy_num_right">
                            <span class="reduce" @click="reduce"><img src="../../assets/images/btn_reduce.png"></span>
                            <input type="number" v-model.number="exchangeNum" @input="inputExchangeNum">
                            <span class="add" @click="add"><img src="../../assets/images/btn_add.png"></span>
                          </section>
                        </div>
                     </div>
                   

                    <div class="popupJifen_div">
                        <div class="popupJifen_div_left">
                          <span class="popupJifen_div_span1">商品总价</span>
                          
                        </div>
                        <div class="popupJifen_div_right">
                          <span class="popupJifen_div_span4">￥{{ allMoneyValue }}</span>
                        </div>
                     </div>

                    <div class="popupJifen_div">
                       <div class="popupJifen_div_left">
                         <span class="popupJifen_div_span1">积分抵扣</span>
                         <span class="popupJifen_div_span2">使用积分{{ canUseExchangeValue }},积分余额{{integrationSum-canUseExchangeValue  }}</span>
                       </div>
                       <div class="popupJifen_div_right">
                         <span class="popupJifen_div_span3">-{{ canUseExchangeValue }}积分</span>
                       </div>
                    </div>

                    <div class="popupJifen_div">
                       <div class="popupJifen_div_left">
                         <span class="popupJifen_div_span1">剩余应付</span>
                         
                       </div>
                       <div class="popupJifen_div_right">
                         <span class="popupJifen_div_span4">￥{{ payMoneyValue }}</span>
                       </div>

                    </div>
                </div>    


                <div class="popupfoot" v-if="mbActiveOutput.exchangeType ==0">
                    <span class="popupfoot_span" @click="addMbActiveTrade()">确认兑换</span>
                </div>

                <div class="popupfoot1" v-if="mbActiveOutput.exchangeType ==1">
                    <span class="popupfoot_span1" >合计</span>
                    <span class="popupfoot_span2" >￥{{ allMoneyValue }}</span>
                    <span class="popupfoot_span3" @click="addMbActiveTrade()">立即支付</span>
                </div>
                <div class="popupfoot1" v-if="mbActiveOutput.exchangeType ==2">
                    <span class="popupfoot_span1" >合计</span>
                    <span class="popupfoot_span2" >￥{{ payMoneyValue }}</span>
                    <span class="popupfoot_span3" @click="addMbActiveTrade()">立即支付</span>
                </div>

            </div>
         </mt-popup>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import {ysygetMbActiveById,addMbActiveTrade ,getShareInfo } from "../../utils/api";
import util from '../../utils/util';
import ping from '../../utils/pingpay.js'
import storage from '../../utils/storage';
import Clipboard from 'clipboard';
import wx from 'weixin-js-sdk';

export default {
  name: "ExchangeItemDetails",
  computed: {
    ...mapState({
      common: state => state.common,
    }),
    allMoneyValue(){

        return this.exchangeNum *this.mbActiveOutput.moneyValue
    },
    allExchangeValue(){
        return this.exchangeNum *this.mbActiveOutput.exchangeValue
    },

    // 最多可抵扣积分 单个最多乘数量
    exchangeTop(){
        var exchangeTop =0
        if(this.exchangeNum>1){
            exchangeTop = this.mbActiveOutput.exchangeTop * this.exchangeNum
        }else{
            exchangeTop = this.mbActiveOutput.exchangeTop
        }
        return exchangeTop

    },

    canUseintegrationSum(){
        // 本次可用积分（Z）：取积分余额（Y）、积分抵扣上限（B）、商品总价（S）换算积分（T）中的最小值；
       
        var changeVal = this.integrationSum>this.exchangeTop? this.exchangeTop:this.integrationSum
        
        // var num =0

        return changeVal 

    }
  },
  data() {
    return {
      canPay:true,
      orderNo:'',
      payMoneyValue:0,
      canUseExchangeValue:0,
      typeList:[1,2,3,4,5,6,7,8,9,10],
      valveList:[],
      imageList:[],
      imgs:[],
      id:'',
      integrationSum:0,
      changeintegration:0,
      exchangeNum:1,
      mbAddress:'',
      exchangeData:'',
      mbActiveOutput:'',
      pickUpActive :'',
      showPopup:false,
      overTime:'',

      moneyValue: '', //商品金额
    }
  },
  created () {
       let query = this.$route.query;
      this.mbActiveId=query.id;
      this.getMbActiveById();

  },
  methods: {
        copyTradeCode () {
            var clipboard = new Clipboard('.addressView_right')
            clipboard.on('success', () => {
                util.showToast('复制成功')
                // 释放内存
                clipboard.destroy()
            })
        },
        getMbActiveById(){
            var param = {
               // "memberCode": "1",
                "mbActiveId": this.mbActiveId,// "6691535467797553251", //"6612566953552773219",
               // "marketId":"25",
                "memberCode": this.common.userInfo.memberCode,
                 "marketId":this.common.marketInfo.id,

            }
            var that =this
            this.orderNo =''
            ysygetMbActiveById( param).then(res => {
                if (res.res.code === 10000) {
                        this.integrationSum =res.body.integrationSum ;
                        this.orderNo=res.body.orderNo
                        this.mbAddress =res.body.mbAddress ;
                        this.mbActiveOutput =res.body.mbActiveOutput ;
                        // console.log(res.body.mbActiveOutput.exchangeData)
                        if(res.body.mbActiveOutput.exchangeData){
                            var arr = JSON.parse(res.body.mbActiveOutput.exchangeData)
                            this.exchangeData = arr[0];
                        }
                        // console.log(this.exchangeData);
                        this.timeFn(parseInt(this.mbActiveOutput.actEndTime) );
                        this.imageList =res.body.imageList;
                        this.imgs =[];
                        var sImag='';
                        if( this.imageList ){
                            for(var i=0;i<this.imageList.length;i++){
                                if(i==0){
                                    sImag = this.imageList[i].imgPath
                                }
                                this.imgs.push(this.imageList[i].imgPath)
                            }
                        }
                        // console.log("this.imgs")
                        // console.log(this.imgs)
                        this.changeintegration = this.mbActiveOutput.exchangeValue;
                        if (this.mbActiveOutput.courierType) {
                            if (this.mbActiveOutput.courierType == 1 || this.mbActiveOutput.courierType.split(',')[0] == 1) {
                                this.pickUpActive = 1
                            } else if (this.mbActiveOutput.courierType == 2 || this.mbActiveOutput.courierType.split(',')[1] == 2) {
                                this.pickUpActive = 0
                            }
                        }
                      
                        let address1 = window.location.href.split('?')[0];
                        wx.ready(() => {
                            if(that.common.cityId){
                                address1 = address1+"?cityId="+that.common.cityId+'&marketId=' + that.common.marketInfo.id
                            }else{
                                address1 = address1+'?marketId=' + that.common.marketInfo.id
                            }
                           
                            address1 = address1+'&id='+this.$route.query.id
                            console.log("address1  ======  " +  address1)
                            // console.log('sImag ==== ' + sImag)
                            let obj = {
                                title: that.mbActiveOutput.actName, // 分享标题
                                desc: '积分:' + that.changeintegration,
                                link: address1, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                imgUrl: sImag,// 分享图标
                                success: function () {
                                    util.showToast('已分享')
                                }
                            }
                            // console.log('readyed') 路由设置 share: true,
                            wx.onMenuShareAppMessage(obj)
                            wx.onMenuShareTimeline(obj)
                            console.log('readyed1111')
                        })

                       
                }
            });
        },
        addMbActiveTrade (){
            let courierType;
            if (this.pickUpActive) {
                courierType = "1"
            } else {
                courierType = "2"
            }

            if(this.exchangeNum<1){

                util.showToast('兑换数量不能小于1')
                return 
            }

           

            var param = {
               // "memberCode": "1",
                "mbActiveId": this.mbActiveId,
                //"6691535467797553251", //"6612566953552773219",
               // "marketId":"25",
                "memberCode": this.common.userInfo.memberCode,
                "marketId":this.common.marketInfo.id,
                "activeId": this.mbActiveOutput.id,
                // "changeVal":   this.mbActiveOutput.exchangeValue* -1,
                "exchangeNum": this.exchangeNum,
                "actType": this.mbActiveOutput.actType,
                "courierType": courierType
            }

            if(this.mbActiveOutput.exchangeType ==2){
                // var  changeVal = this.integrationSum>this.mbActiveOutput.exchangeTop? this.mbActiveOutput.exchangeTop:this.integrationSum

                // var  changeMoney = 0
                // if(changeVal>0){
                //     changeMoney = changeVal/this.mbActiveOutput.exchangeRule
                // }
                param.payAmount = this.payMoneyValue
                param.changeVal =this.canUseExchangeValue * -1
               
                //(this.allMoneyValue -changeMoney).toFixed(2)
                // param.changeVal = changeVal* -1
            }else if(this.mbActiveOutput.exchangeType ==1){
                param.payAmount = this.allMoneyValue
                param.changeVal = this.allExchangeValue * -1
            }else if(this.mbActiveOutput.exchangeType ==0){
                param.changeVal = this.allExchangeValue * -1
            }
            console.log(JSON.stringify(param))

            addMbActiveTrade( param).then(res => {
                if (res.res.code === 10000) {
                    this.showPopup =false;
                     util.showToast(res.res.msg)
                     this.exchangeNum =1
                     if(this.mbActiveOutput.exchangeType ==1  ){
                        this.orderNo =  res.body.orderNo
                        this.goPayCenter(res.body.orderNo)
                     }else   if(this.mbActiveOutput.exchangeType ==2) {
                        if( res.body.orderNo){
                            this.orderNo =  res.body.orderNo
                             this.goPayCenter(res.body.orderNo)
                        }else{
                            this.getMbActiveById();
                        }

                     }else{
                        this.getMbActiveById();
                     }

                }else{
                     util.showToast(res.res.msg)
                     console.log(res.res.msg)
                }
            });


        },

          // 立即支付
        goPayCenter(orderNo) {
            if (!this.canPay) { return; }
            this.canPay = false;
            let params = {
                orderNo:orderNo,
                repairNo: '', // "报修单号",
                bussinessType: "10",//积分兑换 10
                // feeCode: this.orderInfo.actId,
                // payType: '5', // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"
                channel: 'wx_pub' // 渠道名
            };
            ping(
                params,
                '',
                res => {
                    
                    this.canPay = true;
                    this.getMbActiveById();
                },
                () => {
                    this.canPay = true;
                    this.getMbActiveById();
                },
                () => {
                    this.canPay = true;
                    this.getMbActiveById();
                }
            );
            setTimeout(() => { this.canPay = true; }, 3000)
        },
        showPopupAction(){
            this.showPopup =true;
            if(this.mbActiveOutput.exchangeType ==2){

                var  changeVal = this.integrationSum>this.exchangeTop? this.exchangeTop:this.integrationSum

                var  changeMoney = 0
                if(changeVal>0){
                    changeMoney = changeVal/this.mbActiveOutput.exchangeRule
                }
                if(this.allMoneyValue>changeMoney){
                    this.payMoneyValue = (this.allMoneyValue-changeMoney).toFixed(2)
                }else{
                    this.payMoneyValue = 0
                }
                if(changeVal>this.getMaxChangeVal()){
                    this.canUseExchangeValue = this.getMaxChangeVal()
                }else{
                    this.canUseExchangeValue = changeVal
                }
            }
        },
         closePopupAction(){
            this.showPopup =false;
        },

        timeFn(d1) {//di作为一个变量传进来
            //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
            var  dateEnd= new Date(d1);//将-转化为/，使用new Date
            var dateBegin = new Date();//获取当前时间
            var dateDiff = dateEnd.getTime() - dateBegin.getTime();//时间差的毫秒数
            var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
            var leave1=dateDiff%(24*3600*1000) //计算天数后剩余的毫秒数
            var hours=Math.floor(leave1/(3600*1000))//计算出小时数
            //计算相差分钟数
            var leave2=leave1%(3600*1000) //计算小时数后剩余的毫秒数
            var minutes=Math.floor(leave2/(60*1000))//计算相差分钟数
            //计算相差秒数
            var leave3=leave2%(60*1000) //计算分钟数后剩余的毫秒数
            var seconds=Math.round(leave3/1000)
            console.log(" 相差 "+dayDiff+"天 "+hours+"小时 "+minutes+" 分钟"+seconds+" 秒")
            this.overTime = dayDiff+"天 "+hours+"小时 ";
        },

    //     getShareInfoAction(sImag){
    //    // console.log( wx)
    //         var that =this;
       
    //         var url = storage.getS('rootUrl') || window.location.href.split('#')[0]   //ios 使用缓存的 安卓使用当前的
    //         let u = window.navigator.userAgent;
    //         if(u.indexOf('Android') > -1 || u.indexOf('Adr') > -1){
    //             url = window.location.href.split('#')[0]
    //         }
    //         let params = {
    //             url:url
    //         }
    //         if(this.common.cityId){
    //             params.cityId = this.common.cityId
    //         }else{
    //             params.marketId = this.common.marketInfo.id
    //         }
    //         getShareInfo(params).then(res=>{
    //         // // console.log( "getShareInfo  ===  " + window.location.href.split('#')[0])
    //             console.log( "getShareInfo  ===  " + JSON.stringify(res) )
    //             this.isNetworkOnline =true;
    //             if(res.res && res.res.code === 10000 && res.body&& res.body.appid){
                
    //                 var configMap={
    //                     debug: false,
    //                     appId: res.body.appid , // 必填，公众号的唯一标识
    //                     timestamp:res.body.timestamp  , // 必填，生成签名的时间戳，精确到秒
    //                     nonceStr: res.body.nonceStr, // 必填，生成签名的随机串
    //                     signature: res.body.signature, // 必填，签名
    //                     jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','updateAppMessageShareData','updateTimelineShareData','chooseImage', 'uploadImage','downloadImage','chooseWXPay','checkJsApi', 'scanQRCode','hideMenuItems','hideOptionMenu','getLocation']
    //                 }
    //                 wx.config(configMap)
    //                 wx.error(function(res){
    //                         // util.showToast("错误信息== error   " + res.errMsg,6000);
    //                         // 暂时解决不了 比较慢的iOS手机微信版本 获取的URL问题 所以config失败 使用当前url 再config 一次
    //                     console.log('in error  '+ JSON.stringify(res) );
    //                     // var errMsg =  res.errMsg
    //                     // if(errMsg.indexOf('config') > -1 ){
    //                     //     that.errorBackconfig();
    //                     // }
    //                 });
                  

    //             }
    //         })
    //     },

    // 数量变化后的计算 库存  抵扣规则？
    exchangeNumChange(){
        if(this.mbActiveOutput.exchangeType ==2){
            var  changeVal = this.integrationSum>this.exchangeTop? this.exchangeTop:this.integrationSum
            var  changeMoney = 0
            if(changeVal>0){
                changeMoney = changeVal/this.mbActiveOutput.exchangeRule
            }
            if(this.allMoneyValue>changeMoney){
                this.payMoneyValue = (this.allMoneyValue-changeMoney).toFixed(2)
            }else{
                this.payMoneyValue = 0
            }
            if(changeVal>this.getMaxChangeVal()){
                this.canUseExchangeValue = this.getMaxChangeVal()
            }else{
                this.canUseExchangeValue = changeVal
            }
            
        }
    },
    getMaxChangeVal(){
        var maxChangeVal = this.allMoneyValue*this.mbActiveOutput.exchangeRule
        maxChangeVal= Math.ceil(maxChangeVal); //小数进1
        return maxChangeVal
    },


    add(){ 
      if(this.exchangeNum >=this.mbActiveOutput.exchangeNum){
          util.showToast('已达到库存最大数量')
          return;  
      }
     if(this.mbActiveOutput.exchangeType ==0 || this.mbActiveOutput.exchangeType ==1  ) {
        if((this.exchangeNum+1)*this.mbActiveOutput.exchangeValue>this.integrationSum){
            // util.showToast('本次使用积分超过可用限度，请重新选择')
            util.showModal("",'本次使用积分超过可用限度，请重新选择',false,"知道了",() => {
               
            });
            return;
        }
     }
     this.exchangeNum = this.exchangeNum+1
     this.exchangeNumChange()
    },
    reduce(){
 
      if(this.exchangeNum ==1){
        util.showToast('兑换数量不能小于1')
        return 
      }

      this.exchangeNum = this.exchangeNum-1
      this.exchangeNumChange()
    },
    inputExchangeNum(){
       if( this.exchangeNum<1){
        //this.exchangeNum =1
        util.showToast('兑换数量不能小于1')
       }
        if(this.exchangeNum >this.mbActiveOutput.exchangeNum){
          util.showToast('已达到库存最大数量')
          this.exchangeNum = this.mbActiveOutput.exchangeNum
        }

       if(this.mbActiveOutput.exchangeType ==0 || this.mbActiveOutput.exchangeType ==1 ) {
        if((this.exchangeNum)*this.mbActiveOutput.exchangeValue>this.integrationSum){
            // util.showToast('本次使用积分超过可用限度，请重新选择')
            util.showModal("",'本次使用积分超过可用限度，请重新选择',false,"知道了",() => {
               
            });
            this.exchangeNum = parseInt(this.integrationSum/this.mbActiveOutput.exchangeValue)
        }
      }
      this.exchangeNumChange()
    },


     } ,

}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
    position: relative;
    background:#ffffff;
    .flex(column);
}

.top_icon{
    width:100%;
    height:562px;
}
 .top_swiper_box{
        height:562px;
        width:100%;
        // background-color: blue;
        // box-sizing:border-box;
        .gallary-img{
            height:562px;
            width:100%;
        }
}

.top_info{
    width:100%;
    // height:174px;
    background:rgba(255,255,255,1);
    flex-direction: column;
    display: flex;
    position: relative;
    padding-bottom: 18px;
    .top_info_span1{
        margin-top: 28px;
        margin-left: 28px;
        height:50px;
        font-size:36px;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:50px;
        .textOver(500px);

    }
    .top_info_span2{
         margin-top: 20px;
         margin-left: 28px;
        //  height:48px;
         font-size:40px;
         font-weight:500;
         color:rgba(255,126,30,1);
         line-height:48px;
    }
    .top_info_span22{
         margin-top: 20px;
         margin-left: 28px;
        //  height:48px;
         font-size:28px;
         color:rgba(255,126,30,1);
         line-height:48px;
    }
    .top_info_div{
        margin-top: 20px;
        margin-left: 28px;
        flex-direction: row;
        display: flex;
        height: 48px;
        align-items: center;
    }

    .top_info_div_span1{
         font-size:40px;
         font-weight:500;
         color:rgba(255,126,30,1);
         line-height:48px;
    }
    .top_info_div_span2{
        margin-left: 28px;
        padding-left: 14px;
        padding-right: 14px;
        height: 48px;
        background:rgba(252,63,86,0.1);
        border-radius:22px;
        font-size:26px;
        font-weight:400;
        color:rgba(252,63,86,1);
        line-height:48px;
       
    }
    .top_info_span3{
        position: absolute;
        top: 28px;
        right: 28px;
        padding-left: 14px;
        padding-right: 14px;
        height:44px;
        background:rgba(252,63,86,0.1);
        border-radius:22px;
        font-size:26px;
        font-weight:400;
        color:rgba(252,63,86,1);
        line-height:44px;

    }

}
.bodyTopLine{
    width: 100%;
    height: 20px;
    background-color: #eeeeee
}
.body{
    // margin-top: 20px;
    padding-bottom: 20px;
    min-height: 456px;
    margin-bottom: 120px;
    width: 100%;
     background-color: #ffffff;
    flex-direction: column;
    display: flex;
    .body_span1{
        margin-top: 40px;
        margin-left: 28px;
        height:44px;
        font-size:32px;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:44px;

    }
    .body_span2{
        margin-top: 20px;
        margin-left: 28px;
        width:692px;
        font-size:28px;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:40px;

    }
    .body_html{
         margin-top: 20px;
         margin-left: 28px;
         width:692px;
         margin-bottom: 20px;
         /deep/ strong {
            font-weight: bold;
            .fontSize(15px);
            line-height: 50px;
        }
        /deep/ p {
            .fontSize(14px);
            color: rgba(0, 0, 0, 0.9);
            line-height: 40px;
        }
        /deep/ span {
            .fontSize(14px);
            color: rgba(0, 0, 0, 0.9);
            line-height: 40px;
        }
        /deep/ img {
            max-width: 100%;
            min-width: 40%;
            margin: 10px auto;
            height: auto;
            display: block;
        }
        /deep/ figcaption {
            text-align: center;
            .fontSize(14px);
            line-height: 50px;
        }
        /deep/ tr,
        td,
        th {
            .fontSize(14px);
        }
    }


}

 .ExchangefootBg{
        position: fixed;
        left: 0;
        bottom: 0;
        display: flex;
        width: 750px;
        height: 120px;
        background-color: #ffffff;
        .Exchangefoot_span{
            // display: flex;
            margin-top:16px;
            margin-left: 28px;
            width:694px;
            height:88px;
            background:linear-gradient(90deg,rgba(255,181,64,1) 0%,rgba(255,126,30,1) 100%);
            border-radius:8px;
            text-align: center;
            font-size:34px;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:88px;
        }
        .Exchangefoot_span1{
             margin-top:16px;
            margin-left: 28px;
            width:694px;
            height:88px;
            background:#BBBBBB;
            border-radius:8px;
            text-align: center;
            font-size:34px;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:88px;

        }
    }

    .popup{
        width:750px;
        // height:560px;
        // background:rgba(255,255,255,1);
       border-radius:16px 16px 0px 0px;
       .popupJifen{
            margin-top: 32px;
            width: 100%;
            justify-content: center;
            flex-direction: row;
             display: flex;
            .popupJifen_span1{
                height:44px;
                font-size:28px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:40px;

            }
            .popupJifen_span2{
                height:44px;
                font-size:28px;
                font-weight:400;
                color:#FF7E1E;
                line-height:40px;

            }
        }
        .popupJifen1{
            margin-top: 32px;
            width: 100%;
            flex-direction: column;
             display: flex;
            .popupJifen_div{
                width: 100%;
                margin-bottom: 14px;
                justify-content: space-between;
                flex-direction: row;
                display: flex;

                .popupJifen_div_left{
                    margin-left: 28px;
                    flex-direction: row;
                }
                .popupJifen_div_right{
                    margin-right: 28px;
                    flex-direction: row;
                }

                .buy_num_right{
                    flex:1;
                    .flex();
                    justify-content: flex-end;
                    .reduce{
                      display: block;
                      width:56px;
                      height:56px;
                      background:rgba(238,238,238,0.3);
                      border-radius:4px;
                      .flex();
                      justify-content: center;
                      align-items: center;
                      img{
                        display: block;
                        width:24px;
                        height:4px;
                      }
                    }
                    input{
                      display: block;
                      width:108px;
                      height:56px;
                      background:#f8f8f8;
                      margin:0 10px;
                      font-size:28px;
                      color:rgba(51,51,51,1);
                      text-align: center;
                    }
                    .add{
                      display: block;
                      width:56px;
                      height:56px;
                      background:rgba(238,238,238,1);
                      border-radius:4px;
                      .flex();
                      justify-content: center;
                      align-items: center;
                      img{
                        display: block;
                        width:24px;
                        height:24px;
                      }
                    }
                  }
              

                .popupJifen_div_span1{
                    font-size:28px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:40px;

                }
                .popupJifen_div_span2{
                    margin-left: 14px;
                    font-size:24px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:40px;

                }
                .popupJifen_div_span3{
                    font-size:28px;
                    font-weight:400;
                    color:rgba(255,126,30,1);
                    line-height:40px;

                }
                .popupJifen_div_span4{
                    font-size:28px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:40px;

                }
            }
        }
       .popupTop{
           flex-direction: row;
           display: flex;
           width:100%;
           height:100px;
           background:rgba(255,255,255,1);
           border-radius:16px 16px 0px 0px;
           .popupTop_span1{
               margin-left: 28px;
               margin-top: 30px;
               height:42px;
               font-size:30px;
               font-weight:400;
               color:rgba(51,51,51,1);
               line-height:42px;

           }
           .popupTop_span2{
               margin-left: 216px;
               margin-top: 26px;
               height:50px;
               font-size:36px;
               font-weight:500;
               color:rgba(51,51,51,1);
               line-height:50px;
           }
       }
         .popupfoot{
                margin-top: 28px;
                margin-bottom: 14px;
                width: 100%;
                height:120px;
                // background:red;
                display: flex;
                 .popupfoot_span{
                    // display: flex;
                    flex-direction: row;
                    margin-top:16px;
                    margin-left: 28px;
                    width:694px;
                    height:88px;
                    background:linear-gradient(90deg,rgba(255,181,64,1) 0%,rgba(255,126,30,1) 100%);
                    border-radius:8px;
                    text-align: center;
                    font-size:34px;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    line-height:88px;
                }
            }

         .popupfoot1{
            margin-top: 28px;
            width: 100%;
            height:120px;
            margin-bottom: 14px;
                // background:red;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            .popupfoot_span1{
                font-size:34px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:88px;
                margin-right: 16px;
            }
            .popupfoot_span2{
                font-size:34px;
                font-weight:400;
                color:rgba(252,63,86,1);
                line-height:88px;
                margin-right: 32px;
            }
            .popupfoot_span3{
                    // display: flex;
                    flex-direction: row;
                    // margin-top:16px;
                    margin-right: 28px;
                    width:200px;
                    height:88px;
                    background:linear-gradient(90deg,rgba(255,181,64,1) 0%,rgba(255,126,30,1) 100%);
                    border-radius:8px;
                    text-align: center;
                    font-size:34px;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    line-height:88px;
                }

         }
       .addressView{
        width: 100%;
        height:212px;
        background:rgba(255,255,255,1);
        .addressViewBG{
            margin-top: 20px;
            width: 92.54%;
            margin-left: 28px;
            height:196px;
            background:rgba(248,248,248,1);
            border-radius:8px;
            display: flex;
            flex-direction: row;
            .addressView_left{
                margin-left: 20px;
                margin-top: 30px;
                width: 516px;
                // background-color: blue;
                display: flex;
                flex-direction: column;
                .addressView_left_div{
                    display: flex;
                    flex-direction: row;
                    .addressView_left_icon{
                        // background-color: blue;
                        margin-top: 5px;
                        width: 24px;
                        height: 30px;
                    }
                    .addressView_left_span1{
                        height:40px;
                        font-size:28px;
                        margin-left: 4px;
                        font-weight:400;
                        color:rgba(102,102,102,1);
                        line-height:40px;
                    }
                }
                .addressView_left_span2{
                    display: flex;
                    margin-top: 14px;
                    margin-left: 48px;
                    width:468px;
                    height:80px;
                    font-size:28px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:40px;
                }
            }
            .addressView_line{
                margin-left: 28px;
                margin-right: 28px;
                margin-top: 58px;
                width:2px;
                height:80px;
                background:rgba(234,234,234,1);
            }
            .addressView_right{
                margin-left: 14px;
                display: flex;
                flex-direction: column;
                .addressView_right_icon{
                    margin-top: 60px;
                    width: 44px;
                    height: 44px;
                    // background-color: blue;
                }
                .addressView_right_span{
                    margin-top: 4px;
                    height:32px;
                    font-size:22px;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                    line-height:32px;
                }
            }


    }


}
    }

</style>